import StatusBadge from 'components/badges/StatusBadge';

import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const GroundedStatusBadge: FunctionComponent<Props> = ({
    className = '',
    testId = TEST_ID,
    text
}) => {
    const { GROUNDED } = useTranslation();

    return (
        <StatusBadge
            className={`${className} ${styles.groundedStatusBadge}`}
            testId={testId}
            text={text ?? GROUNDED}
        />
    );
};

export default GroundedStatusBadge;
